module.exports = isNode

function isNode (val) {
  return (!val || typeof val !== 'object')
    ? false
    : (typeof window === 'object' && typeof window.Node === 'object')
      ? (val instanceof window.Node)
      : (typeof val.nodeType === 'number') &&
        (typeof val.nodeName === 'string')
}



//////////////////
// WEBPACK FOOTER
// ./~/is-dom/index.js
// module id = 382
// module chunks = 0 1